<ng-template>
    <div class="mc-dropdown__panel"
         [ngClass]="classList"
         [class.mc-dropdown__panel_nested]="parent"
         [style.min-width]="triggerWidth"
         (keydown)="handleKeydown($event)"
         (click)="close()"
         [@transformDropdown]="panelAnimationState"
         (@transformDropdown.start)="onAnimationStart($event)"
         (@transformDropdown.done)="onAnimationDone($event)"
         tabindex="-1">

        <div class="mc-dropdown__content">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>
